enum UserAvailable {
  available = "1",
  unavailable = "0",
}

export default UserAvailable;
